// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + (chunkId === 677 ? "dynamic-import-insitepanel" : chunkId) + "." + {"185":"fc22d9f5aa64b8782cad","677":"07b34adeb24ec92c7c3c"}[chunkId] + ".js";
};